import styled from 'styled-components'

export const ForgotPassword = styled.div`
  font-size: 14px;
  transform: translateY(-20px);
  text-align: right;
  user-select: none;

  a {
    color: ${props => props.theme.palette.primary.alpha};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
`
